/**
 * Product Customer Viewing functionality
 * Shows dynamic customer viewing numbers on product pages
 */
(function() {
  'use strict';

  function initProductCustomerViewing() {
    var wrapper = document.querySelector("[data-customer-view]");

    if (wrapper) {
      var numbersViewer = wrapper.getAttribute("data-customer-view");
      var numbersViewerList = JSON.parse("[" + numbersViewer + "]");
      var numbersViewerTime = wrapper.getAttribute("data-customer-view-time");
      var timeViewer = parseInt(numbersViewerTime) * 1000;
      var textElement = wrapper.querySelector(".text");

      if (textElement && window.customer_view && window.customer_view.text) {
        // Show initial number immediately on page load
        var initialNumberItem = Math.floor(Math.random() * numbersViewerList.length);
        
        textElement.textContent = window.customer_view.text.replace(
          "[number]",
          numbersViewerList[initialNumberItem]
        );

        // Continue with the interval for subsequent changes
        setInterval(function() {
          var numbersViewerItem = Math.floor(Math.random() * numbersViewerList.length);
          
          textElement.textContent = window.customer_view.text.replace(
            "[number]",
            numbersViewerList[numbersViewerItem]
          );
        }, timeViewer);
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCustomerViewing);
  } else {
    initProductCustomerViewing();
  }

  // jQuery version for compatibility (if jQuery is available)
  if (typeof jQuery !== 'undefined') {
    window.productCustomerViewing = function($scope) {
      var wrapper = $scope.find("[data-customer-view]");

      if (wrapper.length > 0) {
        var numbersViewer = wrapper.data("customer-view");
        var numbersViewerList = JSON.parse("[" + numbersViewer + "]");
        var numbersViewerTime = wrapper.data("customer-view-time");
        var timeViewer = parseInt(numbersViewerTime) * 1000;

        // Show initial number immediately on page load
        var initialNumberItem = Math.floor(Math.random() * numbersViewerList.length);

        wrapper
          .find(".text")
          .text(
            window.customer_view.text.replace(
              "[number]",
              numbersViewerList[initialNumberItem]
            )
          );

        // Continue with the interval for subsequent changes
        setInterval(function() {
          var numbersViewerItem = Math.floor(Math.random() * numbersViewerList.length);

          wrapper
            .find(".text")
            .text(
              window.customer_view.text.replace(
                "[number]",
                numbersViewerList[numbersViewerItem]
              )
            );
        }, timeViewer);
      }
    };
  }
})();
